import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { updateVideoDetail } from "../store/action";
import {
  CreateVideoError,
  CreateVideoInput,
  VideoDetailProps,
} from "../store/actionType";
import { ApiError } from "components";
import VideoForm from "./components/VideoForm";

interface UpdateVideoProps {
  videoData: VideoDetailProps;
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & UpdateVideoProps;

const HandleEditVideo: React.FC<Props> = ({
  closeModal,
  videoData,
  onUpdateVideo,
}) => {
  const videoDetailsState = useSelector(
    (state: any) => state.videoDetails?.genericVideoDetailsState
  );
  const [loading, setLoading] = useState(false);
  const [formData, setsetFormData] = useState<CreateVideoInput>({
    title: videoData.title,
    episode_id: videoData?.episode?.id?.toString(),
    category_id: videoData?.category?.id?.toString(),
    season_folder_id: videoData?.season_folder_id.toString(),
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState<CreateVideoError>({});
  const [apiError, setApiError] = useState(null);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setsetFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    var input: CreateVideoInput = {
      title: formData.title,
      episode_id: videoData?.episode?.id?.toString(),
      category_id: videoData?.category?.id?.toString(),
      season_folder_id: videoData?.season_folder_id.toString(),
    };
    var videoId: string = videoData?.id.toString();
    if (formData.title.trim() === "") {
      setError({ title: "Video title is required" });
      return;
    } else {
      setLoading(true);
      setSubmitted(true);
      onUpdateVideo(input, videoId);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!videoDetailsState.isLoading && submitted) {
      if (videoDetailsState.error) {
        setApiError(videoDetailsState.error); // show error
      } else {
        setApiError(null);
        closeModal(false);
      }
    }
  }, [videoDetailsState.isLoading, videoDetailsState.error, submitted]);

  return (
    <>
      <VideoForm
        handleChange={handleChange}
        handleSubmit={handleSave}
        formData={formData}
        videoError={error}
        loading={loading}
        header={"Edit Video Title"}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onUpdateVideo: (input: CreateVideoInput, video_id: string) =>
    dispatch(updateVideoDetail(input, video_id)),
});

export default connect(null, mapDispatchToProps)(HandleEditVideo);
